export default __webpack_public_path__ + "static/media/Rake.e7eb7b28.glb";